import { z } from "zod/v4"

export const PersonalNotificationIcon = z.enum(["info", "present", "warning"])

export type PersonalNotificationIconType = z.infer<typeof PersonalNotificationIcon>
